import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface TemperatureData {
  id: string
  title: string
  color: string
}

export const temperatureColorsAtom = createPrimitiveAtom<
  Record<string, TemperatureData>
  >({})

export async function updateTemperatureColorsAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().procurement.getTemperatureMap()
  const record = indexBy(x => x.id, data)
  dispatch(temperatureColorsAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}